import { render, staticRenderFns } from "./CustomerSelectionDetails.vue?vue&type=template&id=6390aa60&"
import script from "./CustomerSelectionDetails.vue?vue&type=script&lang=js&"
export * from "./CustomerSelectionDetails.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSelectionDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports